import dayjs from 'dayjs'

// 백엔드에 localDatetime이 한국시간으로 저장돼있다. UTC정보 없다. 이 Datetime을 프론트에서 Asia/Seoul취급해야된다.
export function customDayjs(date?: string | number | Date | dayjs.Dayjs | null | undefined) {
  return dayjs.tz(date, 'Asia/Seoul').tz(dayjs.tz.guess())
}

export const dummy = null
